/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

export const MODAL_DETAILED_DESKTOP_MAX_WIDTH = 684
export const MODAL_DETAILED_CLOSE_BUTTON_CONTAINER_ID = 'modal-detailed-close-button-container'
